import { render } from "./NoteBook.vue?vue&type=template&id=4b397a3c&scoped=true"
import script from "./NoteBook.vue?vue&type=script&lang=js"
export * from "./NoteBook.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4b397a3c"

export default script